import { render, staticRenderFns } from "./EmployerProfile.vue?vue&type=template&id=fa3f78b4&scoped=true&"
import script from "./EmployerProfile.vue?vue&type=script&lang=js&"
export * from "./EmployerProfile.vue?vue&type=script&lang=js&"
import style0 from "./EmployerProfile.vue?vue&type=style&index=0&id=fa3f78b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3f78b4",
  null
  
)

export default component.exports